import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { getBranches } from 'apis/branch'
import { getRegions } from 'apis/region'
import { TIME_SLOTS } from 'consts'
import { ACTION } from 'consts'
import { getLockOrderSettings, updateLockOrderSettings } from 'apis/lock-order-settings'

//antd
import {
  Button,
  Row,
  notification,
  Form,
  Drawer,
  Col,
  Select,
  DatePicker,Tabs
} from 'antd'


//components

//icons
import { LoadingOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons'

//apis
import { addBranch, updateBranch } from 'apis/branch'
import { uploadFile } from 'apis/upload'
import { searchAddress } from 'apis/address'

export default function BlockOrderForm({ reloadData, children, infoBranch}) {
  const typingTimeoutRef = useRef(null)
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const dataUser = useSelector((state) => state.navigation)
  const [regions, setRegions] = useState([])
  const [branches, setBranches] = useState([])
  const [timeSlots, setTimeSlots] = useState([])

  const _getRegions = async (query) => {
    try {
      const res = await getRegions(query)
      if (res.status === 200) {
        setRegions(res.data.data)
        if(res.data.data && res.data.data.length >0) {
          setRegionDelivery(res.data.data[0].region_id)
        }
      } 
    } catch (error) {
      console.log(error)
    }
  }

  const _getBranches = async (query) => {
    try {
      const res = await getBranches(query)
      if (res.status === 200){ 
        
        setBranches(res.data.data)
        if(res.data.data && res.data.data.length >0) {
          setBranchPickup(res.data.data[0].branch_id)
        }
      }

    } catch (error) {
      console.log(error)
    }
  }
  const _getTimesSlot = async (query) => {
    try {
      let _timeSlots = TIME_SLOTS.filter((val) => val.disabled == false);
      setTimeSlots(_timeSlots);
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    _getBranches()
    _getRegions()
    _getTimesSlot()
  }, [])

  const [visible, setVisible] = useState(false)
  // duc
  // thời gian blocks orders
  const [timeBlockDeliveries, setTimeBlockDeliveries] = useState([])
  const [regionDelivery, setRegionDelivery] = useState()
  const [dataBlockDeliveries, setDataBlockDeliveries] = useState([])

  const [timeBlockPickup, setTimeBlockPickup] = useState([])
  const [branchPickup, setBranchPickup] = useState()
  const [dataBlockPickups, setDataBlockPickups] = useState([])
  const [keyTab, setKeyTab] = useState('1')

  const [text, setText] = useState('')

  const changeDate = async (date) =>{
    setDataBlockDeliveries([])
    setDataBlockPickups([])
    if(date) {
      console.log(date.format('YYYY-MM-DD'));
      console.log("changeDate");
      try {
        const res = await getLockOrderSettings({date: date.format('YYYY-MM-DD')})
        if (res.status === 200) {
          if( res.data.data.length > 0) {
            console.log("deliveries", res.data.data[0].deliveries);
            console.log("pickups", res.data.data[0].pickups);
            setDataBlockDeliveries(res.data.data[0].deliveries)
            setDataBlockPickups(res.data.data[0].pickups)
          }
        }

        // setblockOrderSettings(res.data.data)
      } catch (e) {
        console.log(e)
      }
    }
  }


  const addDeliveryBlock = () => {
    if(timeBlockDeliveries.length == 0) {
      return;
    }
    setText('');
    console.log(regionDelivery);
    console.log(timeBlockDeliveries);

    let index = dataBlockDeliveries.findIndex((e) => e.region_id == regionDelivery);
    if(index <0){
      dataBlockDeliveries.push({
        'region_id': regionDelivery,
        'times': timeBlockDeliveries,
      })
    } else {
      dataBlockDeliveries[index] = {
        'region_id': regionDelivery,
        'times': timeBlockDeliveries,
      }
    }
    setDataBlockDeliveries(dataBlockDeliveries);
    setText('hello');
  }

  const addPickupBlock = () => {
    if(timeBlockPickup.length == 0) {
      return;
    }
    setText('');
    let index = dataBlockPickups.findIndex((e) => e.branch_id == branchPickup);
    if(index <0){
      dataBlockPickups.push({
        'branch_id': branchPickup,
        'times': timeBlockPickup,
      })
    } else {
      dataBlockPickups[index] = {
        'branch_id': branchPickup,
        'times': timeBlockPickup,
      }
    }
    setDataBlockPickups(dataBlockPickups);
    setText('hello');
  }
  const removePickupBlock = (index) => {
    setText('');
    dataBlockPickups.splice(index,1);
    setDataBlockPickups(dataBlockPickups);
    setText('hello');
  }

  const removeDeliveryBlock = (index) => {
    setText('');
    dataBlockDeliveries.splice(index,1);
    setDataBlockDeliveries(dataBlockDeliveries);
    setText('hello');
  }

  const onFinish = async () => {
    //validated form
    let isValidated = true
    try {
      await form.validateFields()
      isValidated = true
    } catch (error) {
      isValidated = false
    }

    if (!isValidated) return

    try {
      //check validated phone
     

      dispatch({ type: ACTION.LOADING, data: true })

      
      const body = {
        date: form.getFieldValue('date').utc(true),
        pickups: dataBlockPickups,
        deliveries: dataBlockDeliveries,
      }

      console.log(body);
     

      const res = await updateLockOrderSettings(body)
      console.log(res)
      if (res.status === 200) {
        form.resetFields()
        window.location.reload();
      } else {
       
      }
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      dispatch({ type: ACTION.LOADING, data: false })
      console.log(error)
    }
  }

  

  //reset


  const changeRegion = (data) => {
    console.log("changeRegion")
    setText('');
    setTimeBlockDeliveries([]);
    setRegionDelivery(data);
    setText('hello');
  }


  useEffect(() => {
    setText('Updated');
  }, [text])

  console.log('Rendering!!!');
  console.log(dataBlockDeliveries);
  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      <Drawer
        title={'Cập nhật block order'}
        centered
        width="80%"
        footer={
          <Row justify="end">
            <Button size="large" type="primary" onClick={onFinish}>
              Cập nhật
            </Button>
          </Row>
        }
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Row gutter={[30, 0]}>
            <Col md={12}>
              <Form.Item
                  rules={[{ required: true, message: 'Vui lòng nhập ngày!' }]}
                  label="Ngày block"
                  name="date"
              >
                 <DatePicker placeholder="Chọn ngày lock" style={{ width: '100%' }} onChange={changeDate}/>
              </Form.Item>
              <br />
            </Col>
          </Row>
          <Row>
            <Tabs activeKey={keyTab} type="card" onChange={setKeyTab} style={{ width: '100%' }}>
              <Tabs.TabPane tab={`Delivery`} key="1">
              <Row gutter={[30, 0]}>
                <Col md={12}>
                  <b>Delivery</b>
                </Col>
              </Row>  
              <Row gutter={[30, 0]}>
                <Col md={10}>
                    <Select placeholder="Chọn khu vực block" onChange={changeRegion} >
                      {regions.map((region, index) => (
                        <Select.Option value={region.region_id} key={region.region_id}>
                          {region.name}
                        </Select.Option>
                      ))}
                    </Select>
                </Col>
                <Col md={10}>
                    <Select placeholder="Chọn thời gian block" onChange={setTimeBlockDeliveries} style={{ width: '100%' }}
                    mode="multiple"
                    allowClear={true}
                    value={timeBlockDeliveries}
                >
                      {timeSlots.map((timeSlot, index) => (
                        <Select.Option value={timeSlot.value} key={timeSlot.value}>
                          {timeSlot.name}
                        </Select.Option>
                      ))}
                    </Select>
                </Col>
                <Col md={4}>
                  <Button type="primary" onClick={()=>{ addDeliveryBlock() }}>Thêm</Button>
                </Col>
              </Row>
              <Row gutter={[30, 0]} style={{margin: '0'}}>Thông tin block delivery</Row>
              <Row gutter={[30, 0]} style={{margin: '0'}}>
                
                {dataBlockDeliveries.map((dataBlockDelivery, index)=>
                  <Row gutter={[30, 0]} style={{ width: '100%', marginTop : '5px' }}>
                    <Col md={10}>
                      {regions.find((region) => region.region_id == dataBlockDelivery.region_id)?.name}
                    </Col>
                    <Col md={10}>
                      {dataBlockDelivery.times.join(",")}
                    </Col>
                    <Col md={4}>
                      <Button type="primary" onClick={()=>{ 
                        removeDeliveryBlock(index);
                      }}>Xoá</Button>
                    </Col>
                    </Row>
                )}
              
              </Row>
              </Tabs.TabPane>
              <Tabs.TabPane tab={`Pickups`} key="2">
                <Row gutter={[30, 0]}>
                  <Col md={12}>
                    <b>Pickup</b>
                  </Col>
                </Row>  
                <Row gutter={[30, 0]}>
                  <Col md={10}>
                      <Select placeholder="Chọn nhà hàng block" onChange={setBranchPickup}>
                        {branches.map((branch) => (
                                      <Select.Option key={branch.branch_id} value={branch.branch_id}>
                                        {branch.name}
                                      </Select.Option>
                                    ))}
                      </Select>
                  </Col>
                  <Col md={10}>
                      <Select placeholder="Chọn thời gian block" onChange={setTimeBlockPickup} style={{ width: '100%' }}
                      mode="multiple"
                  >
                        {timeSlots.map((timeSlot, index) => (
                          <Select.Option value={timeSlot.value} key={timeSlot.value}>
                            {timeSlot.name}
                          </Select.Option>
                        ))}
                      </Select>
                  </Col>
                  <Col md={4}>
                    <Button type="primary" onClick={()=>{ addPickupBlock() }}>Thêm</Button>
                  </Col>
                </Row>
                <Row gutter={[30, 0]} style={{margin: 0}}>Thông tin Block Pickup</Row>
                <Row gutter={[30, 0]} style={{margin: 0}}>
                  {dataBlockPickups.map((dataBlockPickup, index)=> {
                    console.log(dataBlockPickup.branch_id);
                    console.log(branches);
                    return <Row gutter={[30, 0]} style={{ width: '100%', marginTop : '5px' }}>
                      <Col md={10}>
                        {branches.find((branch) => branch.branch_id == dataBlockPickup.branch_id)?.name}
                      </Col>
                      <Col md={10}>
                        {dataBlockPickup.times.join(",")}
                      </Col>
                      <Col md={4}>
                        <Button type="primary" onClick={()=>{ 
                          removePickupBlock(index);
                        }}>Xoá</Button>
                      </Col>
                      </Row>
                  }
                  )}
                
                </Row>
              </Tabs.TabPane>
            </Tabs>
          </Row>
          
          
        </Form>
      </Drawer>
    </>
  )
}
